module.exports = __webpack_public_path__ + "media/images/usp_checkbox-070048f8f210d1bd5494ad03ee94ee70.svg";